import { m as motion, useReducedMotion } from "framer-motion";

interface Day {
  day: string;
  label: string;
  what: string;
  who: string;
  tone: "mint" | "butter" | "peach" | "ghost";
}

const days: Day[] = [
  { day: "MÅN", label: "Plan", what: "Veckans avstämning. Vad ska in i flödet? Vilka hooks vinner?", who: "Projektledare + er marknadschef", tone: "mint" },
  { day: "TIS", label: "Pre-produktion", what: "Manus skickas på godkännande. Locations, props och rekvisita prickas av.", who: "Regissör + manusförfattare", tone: "ghost" },
  { day: "ONS", label: "Inspelningsblock", what: "1 dag hos er. Vi kör i block — flera klipp på en gång, effektivt regisserat.", who: "Hela teamet, samma ansikten varje gång", tone: "butter" },
  { day: "TOR", label: "Klipp & grade", what: "Råmaterial blir film. Klipp, färg, ljud, grafik och musik.", who: "Klippare + colorist", tone: "ghost" },
  { day: "FRE", label: "Leverans", what: "Färdiga klipp i alla format ni behöver — direkt i delad mapp redo att publicera.", who: "Projektledare", tone: "peach" },
];

const toneClass: Record<Day["tone"], string> = {
  mint: "border-mint/40 bg-mint/[0.06] text-mint",
  butter: "border-butter/40 bg-butter/[0.06] text-butter",
  peach: "border-peach/40 bg-peach/[0.06] text-peach",
  ghost: "border-white/10 bg-surface text-muted-foreground",
};

export function WeekInPulse() {
  const reduce = useReducedMotion();
  return (
    <div className="grid gap-3 md:grid-cols-5">
      {days.map((d, i) => (
        <motion.article
          key={d.day}
          initial={reduce ? { opacity: 1, y: 0 } : { opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
          className={`flex flex-col rounded-2xl border p-5 ${toneClass[d.tone]}`}
        >
          <div className="font-mono text-xs uppercase tracking-[0.2em] opacity-80">{d.day}</div>
          <div className="mt-3 text-xl font-semibold text-foreground">{d.label}</div>
          <p className="mt-2 text-sm leading-relaxed text-foreground/80">{d.what}</p>
          <div className="mt-auto pt-4 text-[11px] uppercase tracking-widest text-muted-foreground">
            {d.who}
          </div>
        </motion.article>
      ))}
    </div>
  );
}
